<template>
  <div class="stations-set-time g-button-modal">
    <div
      v-if="RunningStations === true"
      class="stations-set-time__control-station"
    >
      <h3 class="title">
        {{ $t('messages.sharedTexts.stations.station') }} {{ $t('messages.sharedTexts.controls.controls') }}
      </h3>
      <station-component
        v-bind="{'Data': Rows, Type: 'stationtime'}"
        :store="store"
      />

      <button
        class="g-btn g-btn--rounded wide"
        @click="startMoreStations()"
      >
        <p>
          <span>
            <font-awesome-icon :icon="['fas', 'plus']" />
          </span>
          {{ $t('messages.sharedTexts.controls.startNew') }}
        </p>
      </button>
      <button
        class="g-btn g-btn--rounded wide"
        @click="manuallyStopAllStations($event, Rows, Rows.StId)"
      >
        <p>
          <font-awesome-icon :icon="['fas', 'stop']" />
          {{ $t('messages.sharedTexts.controls.stop') }}
        </p>
      </button>
    </div>
    <div v-else>
      <h3 class="title">
        {{ $t('messages.stationSetTime.setRuntime') }}
      </h3>
      <div class="center">
        <station-component
          v-bind="{'Data': Rows, Type: 'stationtime'}"
          :store="store"
        />
      </div>
      <div class="two-columns">
        <div class="two-columns__column two-columns__column--boxed">
          <input
            v-model="ModalHours"
            class="g-btn g-btn--rounded wide"
            type="number"
            name=""
            placeholder="00"
            @focusout="leavinInputCalc($event)"
          >
          <p>{{ $tc('messages.sharedTexts.time.hour', 0) }}</p>
        </div>
        <div class="two-columns__column two-columns__column--boxed">
          <input
            v-model="ModalMin"
            class="g-btn g-btn--rounded wide"
            type="number"
            name=""
            placeholder="00"
            @focusout="leavinInputCalc($event)"
          >
          <p>{{ $tc('messages.sharedTexts.time.minute', 0) }}</p>
        </div>
      </div>

      <div class="two-columns">
        <div class="two-columns__column">
          <button
            class="g-btn g-btn--rounded wide"
            @click="subOne()"
          >
            - 1 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="subFive()"
          >
            - 5 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="subTen()"
          >
            - 10 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="subFifteen()"
          >
            - 15 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
        </div>
        <div class="two-columns__column">
          <button
            class="g-btn g-btn--rounded wide"
            @click="addOne()"
          >
            + 1 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="addFive()"
          >
            + 5 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="addTen()"
          >
            + 10 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
          <button
            class="g-btn g-btn--rounded wide"
            @click="addFifteen()"
          >
            + 15 {{ $tc('messages.sharedTexts.time.m', 0) }}
          </button>
        </div>
      </div>
      <hr>
      <button
        class="g-btn g-btn--rounded wide"
        @click="startProgram(Id); CloseModal()"
      >
        {{ $t('messages.sharedTexts.controls.start') }}
        <span>
          <font-awesome-icon :icon="['fas', 'play']" />
        </span>
      </button>
      <button
        class="g-btn g-btn--rounded wide"
        @click="cancelProgram(Id)"
      >
        {{ $t('messages.sharedTexts.controls.clear') }}
        <span>
          <font-awesome-icon :icon="['fas', 'undo-alt']" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'
import StationComponent from '@/components/StationComponent'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'StationSetTime',
  components: {
    'station-component': StationComponent,
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      Rows: {},
      SetRainShutDown: 0,
      Hours: 0,
      Days: 0,
      Id: '',
      ModalMin: 0,
      ModalHours: 0,
      RunningStations: false
    }
  },
  watch: {
  },
  mounted() {
    this.Id = this.ModalData.data
    this.Rows = this.ModalData.row
    if(this.ModalData.row.runningEntries.length > 0) {
      this.RunningStations = true
    } else {
      this.RunningStations = false
    }
  },
  methods: {
    /**
     *  \brief   add one min to a station run time
     *  \param   -
     *  \return  void
     */
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    addOne() {
      if(this.ModalMin + 1 >= 60) {
        this.ModalHours = this.ModalHours + 1
        this.ModalMin = 0
      } else {
        this.ModalMin = this.ModalMin + 1
      }
    },
    /**
    *  \brief   subtract one min to a station run time
    *  \param   -
    *  \return  void
    */
    subOne() {
      if(this.ModalMin === 0 && this.ModalHours < 1) {
        this.ModalMin = 0
      } else if(this.ModalMin === 0 && this.ModalHours >= 1) {
        this.ModalHours = this.ModalHours - 1
        this.ModalMin = 59
      } else if(this.ModalMin >= 1) {
        this.ModalMin = this.ModalMin - 1
      }
    },
    subFive() {
      for(var i = 0;i < 5;i++) {
        this.subOne()
      }
    },
    subTen() {
      for(var i = 0;i < 10;i++) {
        this.subOne()
      }
    },
    subFifteen() {
      for(var i = 0;i < 15;i++) {
        this.subOne()
      }
    },
    /**
     *  \brief   add fifteen min to a station run time
     *  \param   -
     *  \return  void
     */
    addFifteen() {
      for(var i = 0;i < 15;i++) {
        this.addOne()
      }
    },
    /**
     *  \brief   add ten min to a station run time
     *  \param   -
     *  \return  void
     */
    addTen() {
      for(var i = 0;i < 10;i++) {
        this.addOne()
      }
    },
    /**
     *  \brief   add five min to a station run time
     *  \param   -
     *  \return  void
     */
    addFive() {
      for(var i = 0;i < 5;i++) {
        this.addOne()
      }
    },
    /**
     *  \brief   when leaving input field, method tjeck if input is of allowed values
     *  \param   event
     *  \return  void
     */
    leavinInputCalc(event) {
      var time
      if(this.ModalSec > 59) {
        this.ModalSec = 59
      }

      if(this.ModalSec === isNaN() || this.ModalSec === undefined || this.ModalSec < 1) {
        this.ModalSec = 0
      }

      if(this.ModalMin > 59) {
        this.ModalMin = 59
      }

      if(this.ModalMin === isNaN() || this.ModalMin === undefined || this.ModalMin < 1) {
        this.ModalMin = 0
      }

      if(this.ModalHours >= 48) {
        this.ModalHours = 48
      }

      if(this.ModalHours === isNaN() || this.ModalHours === undefined || this.ModalHours < 1) {
        this.ModalHours = 0
      }

      time = (this.ModalHours * 3600) + (this.ModalMin * 60) + (this.ModalSec)

      var start = time
      var left = 0
      var hour = Math.floor(start / 3600)
      left = start - (hour * 3600)
      var min = Math.floor(left / 60)
      left = left - (min * 60)
      var sec = Math.floor(left / 1)

      this.ModalHours = 0
      this.ModalMin = 0
      this.ModalSec = 0

      if(hour >= 18) {
        this.ModalHours = 17
        this.ModalMin = 59
        this.ModalSec = 0
      } else {
        this.ModalHours = hour
        this.ModalMin = min
        this.ModalSec = sec
      }
      left = 0
      start = 0
      time = 0
      hour = 0
      min = 0
      sec = 0
    },
    startProgram(Id) {
      var time = 0
      time = (this.ModalHours * 3600) + (this.ModalMin * 60)
      this.SocketMessageSend({component: 'Stations', command: 'Start', 'id': Id, 'time': time})
      this.SocketMessageSend({component: 'Stations', command: 'AutoStatus', 'switch': 'on'})
      this.ModalHours = 0
      this.ModalMin = 0
    },
    cancelProgram() {
      this.ModalHours = 0
      this.ModalMin = 0
    },
    startMoreStations() {
      this.RunningStations = false
    },
    /**
      *  \brief   Stop a running entry
      *  \param   handleID - Entry's handle ID
      *  \return  void
    */
    stopStEntry(handleID) {
      this.SocketMessageSend({component: 'Stations', command: 'Stop', 'handleID': handleID})
      this.SocketMessageSend({component: 'Stations', command: 'AutoStatus', 'switch': 'on'})
    },
    /**
     *  \brief  stops all running entries in a station
     *  \param   event
     *  \return  void
     */
    manuallyStopAllStations(event, data, id) {
      var IdArray = []
      for(var i = 0;i < data.runningEntries.length;i++) {
        IdArray.push([Number(data.runningEntries[i].handleID)])
      }
      this.stopStEntry(IdArray)
      this.CloseModal()
    },

    CloseModal(e) {
      this.$emit('CloseModal')
    }
  }
}
</script>

<style lang="scss">
  /*All styles comes from global-styles*/
  .stations-set-time {
    .station {
      margin: 20px 0 10px 30px;
    }
    .station + .g-btn {
      margin-top: 40px;
    }
  }

</style>
